import { ObjectId } from 'bson';

// Utility function version - untuk digunakan di regular function
export const insertMiniappStoreLogUtil = async (hitAPI, outletId, id) => {
  try { 
    const INSERT_MINIAPP_STORELOG = import.meta.env[
      `VITE_REACT_APP_ENDPOINT_INSERT_MINIAPP_STORELOG_${import.meta.env.MODE}`
    ];

    const payload = {
      id: id,
      status: "miniapp_check",
      partition: outletId,
      done: false,
      _deleted: false
    };
    const response = await hitAPI(INSERT_MINIAPP_STORELOG, 'POST', payload);
    return response;
  } catch (error) {
    console.error('Error inserting miniapp storelog:', error);
    throw error;
  }
};
